import React from "react";

import { Block } from "./styles";

interface SkeletonProps {
    width?: string;
    height?: string;
    radius?: string;
    className?: string;
}

// Скелетоны, а не спиннер: экран собирается из сайдбара и сетки плиток, и спиннер по
// центру перестраивал бы всю раскладку при каждой загрузке.
export const Skeleton = ({ width, height, radius, className }: SkeletonProps) => (
    <Block $width={width} $height={height} $radius={radius} className={className} />
);
